export default __webpack_public_path__ + "tutorial-1@1x.60bec068.png";